import * as z from "zod";

export const MapLegendItemSchema = z.object({
  color: z.string(),
  count: z.number(),
  groupTitle: z.string(),
  inFilter: z.boolean(),
  title: z.string()
});

export const MapLegendSchema = z.object({
  legendItems: z.array(MapLegendItemSchema),
  title: z.string()
});

export const BoundingBoxSchema = z.object({
  sw: z.array(z.number()),
  ne: z.array(z.number())
});

export const TxnTSchema = z.object({
  id: z.string(),
  facilityId: z.string(),
  legend: MapLegendSchema,
  facilityLegend: MapLegendSchema,
  bBox: BoundingBoxSchema,
  filterId: z.string().optional()
});

export const PartialTxnTSchema = z
  .object({
    id: z.string().optional(),
    facilityId: z.string().optional()
  })
  .nullable()
  .optional();

export type TxnTSchemaType = z.infer<typeof TxnTSchema>;
export type PartialTxnTSchemaType = z.infer<typeof PartialTxnTSchema>;
